import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { UserAgent } from 'UserAgent-Types';

interface UserAgentState {
  userAgent: UserAgent;
}

const initialState: UserAgentState = {
  userAgent: {} as UserAgent,
};

const userAgentSlice = createSlice({
  name: 'userAgent',
  initialState,
  reducers: {
    setUserAgent(state, action: PayloadAction<UserAgent>) {
      state.userAgent = action.payload;
    },
  },
});

export const { setUserAgent } = userAgentSlice.actions;
export const userAgentReducer = userAgentSlice.reducer;
export type { UserAgentState };
